module.exports = __webpack_public_path__ + "static/assets/131987db946b072a0c426a4582b153b4.png";